import { fetcher } from '@/utils/fetcher'
import useSwr from 'swr'
import { API_URL } from '@/utils/constants'

export default function useInscription(inscription_id: string) {
	return useSwr(`${API_URL}/inscription/${inscription_id}`, fetcher)
}
